export default __webpack_public_path__ + "static/media/laptops.e0e3378f.jpg";